<template>
    <div ref="dotDropMenu" class="dot-drop-menu" @click.stop="clickEvent" @mouseenter="mouseEvent" @mouseleave="mouseEvent">
        <span >
            <img :src="dotImg" />
        </span>
        <div v-if="show" class="drop-mask"></div>
        <transition name="fade"> 
            <slot v-if="show"></slot>
        </transition> 
    </div>
</template>
<script>
export default {
    name: 'DotDropMenu',
    data () {
        return {
            show: 0,
            dotImg: require('../../assets/img/icon/dot_gray.svg'),
        }
    },
    mounted() {
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            // console.log(_this)
            // console.log(e)
            // if( el.contains(e.target) != true){
                _this.dropUp();
            // }
        })
    },
    methods: {
        dropDown: function () {
            this.show = !this.show;
            if( this.show == 1){
                this.dotImg = require('../../assets/img/icon/dot_green.svg')
            }else{
                this.dotImg = require('../../assets/img/icon/dot_gray.svg')
            }
        },
        dropUp: function () {
            this.show = 0;
            this.dotImg = require('../../assets/img/icon/dot_gray.svg')
        },
        clickEvent: function () {
            this.show = !this.show
            // let tag = event.target.tagName;
            // // console.log(tag)
            // if( tag == 'LI' ){
            //     this.dropUp();
            // }else if( tag == 'DIV' || tag == 'SPAN' || tag == 'IMG'){
            //     this.dropDown()
            // }
        },
        mouseEvent: function () {
            // console.log(event)
            if( event.type == 'mouseenter' ){
                this.dotImg = require('../../assets/img/icon/dot_orange.svg')
            }else{
                this.dropUp();
                this.dotImg = require('../../assets/img/icon/dot_gray.svg')
            }
        }
    }
}
</script>
<style lang="scss">
    .dot-drop-menu{
        position: relative;
        cursor: pointer;
        .drop-mask{
            width: 100px;
            height: 20px;
            position: absolute;
            left: -100px;
            top: 7px;
        }
        ul{
            position: absolute;
            width: 187px;
            padding: 4px 0;
            margin-top: 30px;
            border-radius: 4px;
            background: #f0f0f0;
            top: -3px;
            right: 0;
            border: solid 1px #eeeeee;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            z-index: 6;
            li{
                position: relative;
                padding: 12px 25px;
                display: flex;
                align-items: center;
                cursor: pointer;
            }
            li:hover{
                background: #fff;
            }
        }
    }
   
</style>


// WEBPACK FOOTER //
// src/components/widge/DotDropMenu.vue